if (!window.Eurus.loadedScript.has('color-selector.js')) {
  window.Eurus.loadedScript.add('color-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xColorSelector', (sectionId, isProductPage) => ({
        cachedResults: [],
        updateColorProduct(url) {
          const link = isProductPage ? `${url}` : `${url}?section_id=${sectionId}`;

          if (this.cachedResults[link]) {
            const html = this.cachedResults[link];
            this._updateTitle(html);
            this._handleSwapProduct(html);
            this._updateFbtContainer(html);
          } else {
            fetch(link)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                this._updateTitle(html);
                this._handleSwapProduct(html);
                this._updateFbtContainer(html);
                this.cachedResults[link] = html;
              });
          }
          this._updateURL(url);
        },
        _updateURL(url) {
          if (!isProductPage) return;
          window.history.replaceState({}, '', `${url}`);
        },
        _updateTitle(html) {
          if (!isProductPage) return;
          const titleEl = html.querySelector('.product-title');
          if (titleEl) {
            document.querySelector('head title').textContent = titleEl.textContent;
          }
          const destination = document.querySelector('#breadcrumbs--' + sectionId);
          const source = html.querySelector('#breadcrumbs--' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _updateFbtContainer(html) {
          if (!isProductPage) return;
          const destination = document.querySelector('#popup-fbt-' + sectionId);
          const source = html.querySelector('#popup-fbt-' + sectionId);
          if (source && destination) destination.outerHTML = source.outerHTML;
        },
        _handleSwapProduct(html) {
          const destination = isProductPage ? document.querySelector('.main-product') : document.querySelector('.x-product-' + sectionId);
          const source = isProductPage ? html.querySelector('.main-product') : html.querySelector('.x-product-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      }));
    });
  });
}
